import { styled, css } from "styled-components";
import { rotateEffect } from "../../animations/effects.es.js";
const IconWrapper = styled("span")(
  {
    transitionTimingFunction: "ease-out"
  },
  ({ $color }) => ({ color: $color }),
  ({ $display }) => ({ display: $display }),
  ({ $transform }) => ({ transform: $transform }),
  ({ $transitionDuration }) => ({
    transitionDuration: `${$transitionDuration}ms`
  }),
  ({ $animation }) => ({
    rotate: css`
        animation: 1s linear infinite forwards ${rotateEffect};
      `
  })[$animation]
);
export {
  IconWrapper
};
